// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-item_leftBlockListItem__tenOH {
    width: 100%;
    min-height: 64px;
    margin-bottom: 15px;
    padding: 20px;
    background: var(--color-content);
    border-radius: 5px;
    cursor: pointer;
    overflow: hidden;
    position: relative;
}

.content-item_leftBlockListItemTop__hv\\+Uw {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 5px;
}
.content-item_leftBlockListItemTitle__41-ND {
    color: var(--color-icon-stroke);
    font-size: 18px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
}

.content-item_notification__ffKD8 {
    width: 34px;
    height: 24px;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--color-notifiaction-background);
}

.content-item_notificationCount__DbrWu {
    color: var(--color-content);
    font-weight: 700;
    font-size: 12px;
    margin-left: 3px;
}

.content-item_leftBlockListItemBottomCamera__dRPRa {
    width: 18px;
    height: 18px;
    margin-right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.content-item_leftBlockListItemBottomCameraText__cL5U3 {
    font-size: 14px;
    color: var(--color-highlighted-typography);
}
.content-item_leftBlockListItemBottom__MYAiq {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.content-item_activeLeftBlockListItem__ZmUxr {
    box-shadow: 0px 5px 25px 0px var(--color-item-shadow);
}
.content-item_activeLeftBlockListItemBorder__dMFzx {
    width: 4px;
    height: 100%;
    background: var(--color-item-highlight);
    position: absolute;
    left: 0;
    top: 0;
}

`, "",{"version":3,"sources":["webpack://./src/components/content-item/content-item.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,+BAA+B;IAC/B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,qDAAqD;AACzD;AACA;IACI,UAAU;IACV,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,OAAO;IACP,MAAM;AACV","sourcesContent":[".leftBlockListItem {\n    width: 100%;\n    min-height: 64px;\n    margin-bottom: 15px;\n    padding: 20px;\n    background: var(--color-content);\n    border-radius: 5px;\n    cursor: pointer;\n    overflow: hidden;\n    position: relative;\n}\n\n.leftBlockListItemTop {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin-bottom: 5px;\n}\n.leftBlockListItemTitle {\n    color: var(--color-icon-stroke);\n    font-size: 18px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 10px;\n}\n\n.notification {\n    width: 34px;\n    height: 24px;\n    border-radius: 3px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: var(--color-notifiaction-background);\n}\n\n.notificationCount {\n    color: var(--color-content);\n    font-weight: 700;\n    font-size: 12px;\n    margin-left: 3px;\n}\n\n.leftBlockListItemBottomCamera {\n    width: 18px;\n    height: 18px;\n    margin-right: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.leftBlockListItemBottomCameraText {\n    font-size: 14px;\n    color: var(--color-highlighted-typography);\n}\n.leftBlockListItemBottom {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n}\n.activeLeftBlockListItem {\n    box-shadow: 0px 5px 25px 0px var(--color-item-shadow);\n}\n.activeLeftBlockListItemBorder {\n    width: 4px;\n    height: 100%;\n    background: var(--color-item-highlight);\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leftBlockListItem": `content-item_leftBlockListItem__tenOH`,
	"leftBlockListItemTop": `content-item_leftBlockListItemTop__hv+Uw`,
	"leftBlockListItemTitle": `content-item_leftBlockListItemTitle__41-ND`,
	"notification": `content-item_notification__ffKD8`,
	"notificationCount": `content-item_notificationCount__DbrWu`,
	"leftBlockListItemBottomCamera": `content-item_leftBlockListItemBottomCamera__dRPRa`,
	"leftBlockListItemBottomCameraText": `content-item_leftBlockListItemBottomCameraText__cL5U3`,
	"leftBlockListItemBottom": `content-item_leftBlockListItemBottom__MYAiq`,
	"activeLeftBlockListItem": `content-item_activeLeftBlockListItem__ZmUxr`,
	"activeLeftBlockListItemBorder": `content-item_activeLeftBlockListItemBorder__dMFzx`
};
export default ___CSS_LOADER_EXPORT___;
